// API Configuration
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.ezzydental.com/v1',
  ENDPOINTS: {
    // Auth endpoints
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      FORGOT_PASSWORD: '/auth/forgot-password',
      RESET_PASSWORD: '/auth/reset-password',
      VERIFY_EMAIL: '/auth/verify-email',
      REFRESH_TOKEN: '/auth/refresh-token',
    },
    
    // User endpoints
    USER: {
      PROFILE: '/user/profile',
      UPDATE_PROFILE: '/user/profile',
      CHANGE_PASSWORD: '/user/change-password',
    },
    
    // Practice management endpoints
    PRACTICE: {
      DETAILS: '/practice',
      STAFF: '/practice/staff',
      SETTINGS: '/practice/settings',
    },
    
    // Appointments endpoints
    APPOINTMENTS: {
      LIST: '/appointments',
      CREATE: '/appointments',
      DETAILS: (id) => `/appointments/${id}`,
      UPDATE: (id) => `/appointments/${id}`,
      DELETE: (id) => `/appointments/${id}`,
      OPTIMIZE: '/appointments/optimize',
    },
    
    // Patients endpoints
    PATIENTS: {
      LIST: '/patients',
      CREATE: '/patients',
      DETAILS: (id) => `/patients/${id}`,
      UPDATE: (id) => `/patients/${id}`,
      DELETE: (id) => `/patients/${id}`,
      SEARCH: '/patients/search',
    },
    
    // Clinical tools endpoints
    CLINICAL: {
      XRAY_ANALYSIS: '/clinical/xray-analysis',
      TREATMENT_PLANS: '/clinical/treatment-plans',
      MEDICAL_HISTORY: '/clinical/medical-history',
    },
    
    // Inventory endpoints
    INVENTORY: {
      LIST: '/inventory',
      CREATE: '/inventory',
      DETAILS: (id) => `/inventory/${id}`,
      UPDATE: (id) => `/inventory/${id}`,
      DELETE: (id) => `/inventory/${id}`,
    },
    
    // Analytics endpoints
    ANALYTICS: {
      DASHBOARD: '/analytics/dashboard',
      REVENUE: '/analytics/revenue',
      APPOINTMENTS: '/analytics/appointments',
      PATIENTS: '/analytics/patients',
    },
    
    // Demo request endpoints
    DEMO: {
      REQUEST: '/demo/request',
    },
  },
  
  // HTTP status codes
  STATUS_CODES: {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500,
  },
};

export default API_CONFIG; 